import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";
import { Spinner } from "pro-features/components/Loaders/src/Spinner";
import type { IntegrationSyncStatus } from "../../types";
import { INTEGRATION_STATUS } from "app/pages/sales-intelligence/pages/management/constants/constants";

export const StyledIntegrationIndicatorContainer = styled.div<{
    status: IntegrationSyncStatus;
}>`
    ${setFontVariant("caption", colorsPalettes.carbon[250])}
    line-height: 16px;
    background: ${colorsPalettes.carbon[0]};
    border: 1px solid ${colorsPalettes.carbon[200]};
    padding: 3px 6px 3px 6px;
    border-radius: 19px;
    display: flex;
    align-items: center;

    ${({ status }) => {
        switch (status) {
            case INTEGRATION_STATUS.Succeeded:
                return `
                  color: ${colorsPalettes.mint[500]};
                  border: 1px solid transparent;
                `;

            case INTEGRATION_STATUS.Failed:
                return `
                  color: ${colorsPalettes.red["s100"]};
                  border: 1px solid ${colorsPalettes.red["s100"]};
                `;

            case INTEGRATION_STATUS.InProgress:
            case INTEGRATION_STATUS.New:
                return `
                  color: ${colorsPalettes.orange[300]};
                  border: 1px solid ${colorsPalettes.orange[300]};
                `;

            default:
                return ``;
        }
    }};
`;

export const StyledIntegrationText = styled.div<{ withIcon?: boolean }>`
    ${({ withIcon }) => {
        return (
            withIcon && {
                marginLeft: "5px",
            }
        );
    }}
`;

export const IntegrationSpinner = styled(Spinner)`
    display: inline-block;
    vertical-align: baseline;
    width: 12px;
    height: 12px;
    border-color: ${colorsPalettes.orange[300]};
    border-right-color: transparent;
`;
